
































































import InventorySearchFilter from "../components/InventorySearchFilter.vue";
import InventoryItem from "../components/InventoryItem.vue";
import InventoryEditItem from "../components/InventoryEditItem.vue";
import InventoryUploadCSV from "../components/InventoryUploadCSV.vue";
import InventoryExport from "../components/InventoryExport.vue";
import InventoryDeleteItem from "../components/InventoryDeleteItem.vue";
import InventoryCannotDeleteItem from "../components/InventoryCannotDeleteItem.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import config from "../config";

@Component({
  components: {
    InventorySearchFilter,
    InventoryItem,
    InventoryEditItem,
    InventoryUploadCSV,
    InventoryExport,
    InventoryDeleteItem,
    InventoryCannotDeleteItem,
  },
})
export default class ClientInventoryList extends Vue {
  fields: any[] = [
    { key: 'Selected', label: '', sortable: false, thStyle: { width: '2.5rem' }, tdClass: 'text-nowrap' },
    { key: 'ControlNo', sortable: true, thStyle: { width: '6rem' }, tdClass: 'text-nowrap' },
    { key: 'Manufacturer', sortable: true, thStyle: { width: '12%' } },
    { key: 'Model', sortable: true, thStyle: { width: '9%' } },
    { key: 'Nomenclature', sortable: true, thStyle: { width: '16%' } },
    { key: 'SerialNo', sortable: true, thStyle: { width: '12%' } },
    { key: 'Location', sortable: true, thStyle: { width: '8%' } },
    { key: 'PM', sortable: true, thStyle: { width: '3.5rem' }, tdClass: 'text-nowrap' },
    { key: 'ST', sortable: true, thStyle: { width: '3.5rem' }, tdClass: 'text-nowrap' },
    { key: 'Actions', sortable: false, thStyle: { width: '13rem' }, tdClass: 'text-nowrap' },
  ];

  list: Array<{
    Selected: boolean;
    inventoryId: string;
    ID: number;
    ControlNo: string;
    Manufacturer: string;
    Nomenclature: string;
    Model: string;
    SerialNo: string;
    Location: string;
    PM: string;
    ST: string;
    clientId: string;
  }> = [];
  rows = this.list.length;

  filters: any = {
    count: 0,
    page: 1,
    limit: 10,
    skip: 0,
    search_keyword: undefined,
    where: {
      controlNo: undefined,
      qrserialNo: undefined,
      nomenclature: undefined,
      model: undefined,
      manufacturer: undefined,
    },
  }

  created() {
    this.fetchInventoryList();
    this.getClients();
    this.getTechnicians();
  }

  manufacturers: any = [];
  nomenclatures: any = [];
  models: any = [];

  organization: any = null;

  inventoryList = [];

  public async fetchInventoryList(): Promise<void> {
    this.filters.skip = (this.filters.page - 1) * this.filters.limit;

    this.filters.skip = 0;
    this.filters.limit = 0;

    const response: any = await axios({
      method: 'post',
      url: config.apiEndpoint + "inventory/search",
      data: this.filters,
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    if (!response.data.success) return;

    this.filters.count = response.data.data.inventory_count;

    const inventory = response.data.data.inventory;

    const _inventory: any = [];

    inventory.forEach((item: any) => {
      _inventory.push({
        Selected: false,
        inventoryId: item.inventoryId,
        ID: item.numberId,
        ControlNo: item.controlNo,
        Manufacturer: item.manufacturer,
        Nomenclature: item.nomenclature,
        Model: item.model,
        SerialNo: item.qrserialNo,
        Location: item.location,
        PM: item.pm ? 'Yes' : 'No',
        ST: item.safetyTest ? 'Yes' : 'No',
        manualManufacturer: item.manualManufacturer,
        manualNomenclature: item.manualNomenclature,
        manualModel: item.manualModel,
        clientId: item.clientId,
        location: item.location,
        pm: item.pm,
        frequency: item.frequency,
        startingMonth: item.startingMonth,
        safetyTest: item.safetyTest,
      });

      if (!this.manufacturers.includes(item.manufacturer)) this.manufacturers.push(item.manufacturer);
    });

    this.list = _inventory;

    this.inventoryList = inventory;
  }

  clients: any = null;

  async getClients() {
    const response: any = await axios({
      method: 'post',
      url: config.apiEndpoint + "clients/search",
      data: {},
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    if (response.data.success) {
      this.clients = response.data.data.clients;
    }
  }

  technicians = [];

  async getTechnicians() {
    const response: any = await axios({
      method: 'get',
      url: config.apiEndpoint + "users/fetchTechnicians",
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    if (response.data.success) {
      this.technicians = response.data.data.technicians;
    }
  }

}
